import { BasePreviewViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext, toDate } from 'core/utils';
import { LocalPatientService } from "application/patient/services";
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { MissingDocumentService } from 'application/missing-document/services';
import { LookupService } from "common/services";
import { PatientMissingDocsEditViewStore } from "application/patient-missing-docs/stores";
import { action, observable } from 'mobx';
import _ from 'lodash';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import moment from 'moment';

@applicationContext
class PatientMissingDocsPreviewViewStore extends BasePreviewViewStore {
    @observable accessor facilityOrderTemplateStores = false;
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new LocalPatientService(rootStore.application.baasic.apiClient);
        const facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'patient-missing-docs-preview',
            autoInit: false,
            id: id,
            actions: () => {
                return {
                    get: async (id) => {
                        this.facilityOrderPatients = (await facilityOrderPatientService.find({ rpp: 1000, patientId: id, embed: "EligibilityStatus", fields: "facilityOrderId,patientId,eligibilityStatus" })).data.item;
                        const response = await service.get(id);
                        return response.data;
                    }
                }
            }
        });

        this.showBackButton = this.rootStore.menuStore.activeMenuItem && this.rootStore.menuStore.activeMenuItem.route == 'master.app.main.facility-missing-docs.search';

        this.localPatientStore = new BaasicDropdownStore({
            filterable: true,
            initFetch: false
        }, {
            fetchFunc: async (term) => {
                const response = await service.find({
                    sort: "lastName|asc",
                    searchQuery: term,
                    rpp: 100,
                    fields: "id,lastName,firstName,dateOfBirth"
                });

                return response.data.item.map(item => {
                    return {
                        name: `${item.lastName}, ${item.firstName} ${toDate(item.dateOfBirth)}`,
                        ...item
                    }
                });
            },
            onChange: (selected) => {
                var patient = this.localPatientStore.items.find(x => x.id === selected);
                if (patient) {
                    window.location.replace(this.rootStore.routerStore.findRoute("master.app.main.patient-missing-docs.preview").pattern.replace(":id", patient.id));
                    return this.rootStore.routerStore.goTo('master.app.main.patient-missing-docs.preview', { id: patient.id });
                }
            }
        });

        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);

        this.fetch([
            this.initialize()
        ]);
    }

    @action
    async initialize() {
        await this.getResource(this.id);
        await this.getMissingDocuments();
        await this.fetchFacilityOrderTemplates();
        this.localPatientStore.setValue({...this.item, name: `${this.item.lastName}, ${this.item.firstName} ${toDate(this.item.dateOfBirth)}`});
        this.localPatientStore.filterAsync();
    }

    @action.bound
    async getMissingDocuments() {
        const missingDocumentService = new MissingDocumentService(this.rootStore.application.baasic.apiClient);
        this.missingDocuments = (await missingDocumentService.find({ rpp: 100, isActive: true, sort: 'name|asc' })).data.item;

        const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
        this.lookups = await lookupService.getLookups("ImportAction,SpecialtyType");
    }

    @action.bound
    async fetchFacilityOrderTemplates() {
        if(this.item.facilityId){
            const latestFacilityOrder = await this.facilityOrderTemplateService.find({ facilityId: this.item.facilityId, pageSize: 1, fields: "facilityOrderId", orderBy: "FacilityOrder.DateOfService", orderDirection: "asc" });
            this.latestFacilityOrderId = latestFacilityOrder.data.item && latestFacilityOrder.data.item[0] && latestFacilityOrder.data.item[0].facilityOrderId;
        }
      
        let params = {
            pageSize: 10000,
            patientId: this.id,
            facilityId: this.item.facilityId,
            embed: 'Patient,SubCategory,SubCategory.ItemCategory,FacilityOrder,ClinicalStatus,FacilityOrderTemplateMissingDocuments,FacilityOrderTemplateItems',
            orderBy: "FacilityOrder.DateOfService",
            orderDirection: "asc",
        }

        const facilityOrderTemplates = (await this.facilityOrderTemplateService.find({...params, dosDateFrom: moment(new Date()).add(-1,'y').format('YYYY-MM-DD')})).data.item;
        let newFacilityOrderTemplates = facilityOrderTemplates.filter(x=> !x.templateId && (!x.facilityOrder.isEnteralWeek || x.subCategory.itemCategory.abrv === 'enteral'));
        let grouped = _.groupBy(facilityOrderTemplates.filter(x=> x.templateId && (!x.facilityOrder.isEnteralWeek || x.subCategory.itemCategory.abrv === 'enteral')), 'templateId');
        let facilityOrderTemplatesGroupByPatient = [];
        _.each(grouped, (val, key) => {
            facilityOrderTemplatesGroupByPatient.push({ id: key, item: val, missingDocuments: this.missingDocuments, lookups: this.lookups, latestFacilityOrderId: this.latestFacilityOrderId, facilityOrderPatients: this.facilityOrderPatients});
        });
        _.each(newFacilityOrderTemplates, (val) => {
            facilityOrderTemplatesGroupByPatient.push({ id: val.id, item: [val], missingDocuments: this.missingDocuments, lookups: this.lookups, latestFacilityOrderId: this.latestFacilityOrderId, facilityOrderPatients: this.facilityOrderPatients });
        });

        this.facilityOrderTemplateStores = facilityOrderTemplatesGroupByPatient.map(item =>
            new PatientMissingDocsEditViewStore(this.rootStore, item)
        );
    }

    @action.bound
    goBack() {
        return this.rootStore.routerStore.goTo(
            'master.app.main.facility-missing-docs.preview',
            { id: this.item.facilityId, showOnlyPastTemplates: 'false' }
        )
    }
}

export default PatientMissingDocsPreviewViewStore;
